import React from "react";
import { Button, Modal } from "react-bootstrap";
import _ from 'lodash';
import './ForgetPasswordDialog.css';


export default function ForgetPasswordDialog(props) {

    return (
        <Modal id="forgetPasswordDialog" show={props.show} onHide={props.handleClose} centered backdrop="static" >
            <Modal.Header closeButton>
                <Modal.Title>
                    {<div className="content-title">
                        <span>{props.intl.formatMessage({ id: "login_forgot_password" })}</span>
                    </div>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>{props.intl.formatMessage({ id: "ce_forget_password_dialog_message" })}</span>
                <div className="label mgT"><span>{props.intl.formatMessage({ id: "username_email" })}</span></div>
                <div className="inputField"><input id="forgetMailAddress" type="text" name="name" size="30" maxLength="128" /></div>
                <div className="errMsg"></div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" className="primaryBtn" onClick={forgetPassword.bind(this, props)}>{props.intl.formatMessage({ id: "send_button" })}</Button>
                <Button variant="secondary" onClick={props.handleClose}>{props.intl.formatMessage({ id: "header_cancel" })}</Button>
            </Modal.Footer>
        </Modal>
    );
};

function forgetPassword(props) {
    let body = { mailAddress: document.getElementById("forgetMailAddress").value };
    if (!body.mailAddress) {
        document.getElementById("forgetPasswordDialog").getElementsByClassName("errMsg")[0].style.visibility = 'visible';
        document.getElementById("forgetPasswordDialog").getElementsByClassName("errMsg")[0].innerHTML = props.intl.formatMessage({ id: "fields_compulsory" });
        return;
    }
    document.getElementById("forgetPasswordDialog").getElementsByClassName("primaryBtn")[0].disabled = true;
    fetch(process.env.REACT_APP_CE_FORGET_PASSWORD, {method: "PUT", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)})
    .then(response => {
        if (!response.ok) {
            document.getElementById("forgetPasswordDialog").getElementsByClassName("errMsg")[0].style.visibility = 'visible';
            if (response.status === 400) {
                document.getElementById("forgetPasswordDialog").getElementsByClassName("errMsg")[0].innerHTML = props.intl.formatMessage({ id: "error_id_not_exist" });
            } else {
                document.getElementById("forgetPasswordDialog").getElementsByClassName("errMsg")[0].innerHTML = props.intl.formatMessage({ id: "error_send_mail" });
            }
        } else {
            props.handleClose();
            props.displaySnackbar();
        }
    }).catch(e => {
        document.getElementById("forgetPasswordDialog").getElementsByClassName("errMsg")[0].style.visibility = 'visible';
        e.message === 'Failed to fetch' ? document.getElementById("forgetPasswordDialog").getElementsByClassName("errMsg")[0].innerHTML = props.intl.formatMessage({ id: "errCode_10006" }) : document.getElementById("forgetPasswordDialog").getElementsByClassName("errMsg")[0].innerHTML = props.intl.formatMessage({ id: "server_error" });
    }).finally(() => {
        document.getElementById("forgetPasswordDialog").getElementsByClassName("primaryBtn")[0].disabled = false;
    });
}
